import { types } from 'mobx-state-tree'

import {
  CARRIAGE_MODE_AIR,
  CARRIAGE_MODE_RAIL,
  CARRIAGE_MODE_SEA,
  CARRIAGE_MODE_SEA_AIR,
  CARRIAGE_TYPE_FCL,
  CARRIAGE_TYPE_LCL,
} from '../Carriage'

export const CarriageTypeEnum = types.enumeration([CARRIAGE_TYPE_FCL, CARRIAGE_TYPE_LCL])

export const CarriageModeEnum = types.enumeration([
  CARRIAGE_MODE_SEA,
  CARRIAGE_MODE_AIR,
  CARRIAGE_MODE_SEA_AIR,
  CARRIAGE_MODE_RAIL,
])
